import { render, staticRenderFns } from "./DoHeaderForm.vue?vue&type=template&id=a99b8b9a&scoped=true"
import script from "./DoHeaderForm.vue?vue&type=script&lang=js"
export * from "./DoHeaderForm.vue?vue&type=script&lang=js"
import style0 from "./DoHeaderForm.vue?vue&type=style&index=0&id=a99b8b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99b8b9a",
  null
  
)

export default component.exports